var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEssentiaExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 433.83,
    height: 316.328,
    viewBox: "0 0 433.83 316.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_13",
    "data-name": "Ret\\xE2ngulo 13",
    width: 433.83,
    height: 128.904,
    fill: "#f5f5f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    transform: "translate(-729 -239.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    transform: "translate(729 427.036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_37",
    "data-name": "Caminho 37",
    d: "M.062,3.039V67.353H44.127V57.422H11.343V39.583H43.452V29.652H11.343V12.971H44.127V3.039Z",
    transform: "translate(-0.042 -2.075)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_38",
    "data-name": "Caminho 38",
    d: "M168.619,47.536a27.741,27.741,0,0,0,20.345,8.871c9.257,0,12.921-4.532,12.921-8.775,0-5.785-6.846-7.521-14.656-9.546-10.51-2.6-22.852-5.689-22.852-19.285,0-10.606,9.353-18.8,23.43-18.8,10.028,0,18.128,3.182,24.106,8.967l-6.46,8.388a26.144,26.144,0,0,0-18.609-7.328c-6.653,0-10.9,3.182-10.9,8,0,5.014,6.557,6.653,14.174,8.582,10.607,2.7,23.238,5.978,23.238,19.959,0,10.7-7.521,19.863-24.877,19.863-11.86,0-20.442-4.146-26.13-10.221Z",
    transform: "translate(-110.842)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_39",
    "data-name": "Caminho 39",
    d: "M349.142,47.536a27.741,27.741,0,0,0,20.345,8.871c9.256,0,12.921-4.532,12.921-8.775,0-5.785-6.846-7.521-14.656-9.546C357.242,35.484,344.9,32.4,344.9,18.8,344.9,8.2,354.253,0,368.331,0c10.028,0,18.127,3.182,24.105,8.967l-6.46,8.388a26.145,26.145,0,0,0-18.609-7.328c-6.653,0-10.9,3.182-10.9,8,0,5.014,6.557,6.653,14.174,8.582,10.607,2.7,23.238,5.978,23.238,19.959,0,10.7-7.521,19.863-24.877,19.863-11.86,0-20.442-4.146-26.13-10.221Z",
    transform: "translate(-234.09)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_40",
    "data-name": "Caminho 40",
    d: "M536.467,3.039h44.065v9.932H547.748V29.652h32.109v9.932H547.748V57.422h32.784v9.932H536.467Z",
    transform: "translate(-366.26 -2.075)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_41",
    "data-name": "Caminho 41",
    d: "M723.106,20.492V67.353H711.824V3.039h11.571l32.88,45.608V3.039h11.282V67.353h-10.9Z",
    transform: "translate(-485.981 -2.075)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_42",
    "data-name": "Caminho 42",
    d: "M937.047,12.971H917.569V3.039h50.236v9.932H948.328V67.353H937.047Z",
    transform: "translate(-626.449 -2.075)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_11",
    "data-name": "Ret\\xE2ngulo 11",
    width: 11.281,
    height: 64.314,
    transform: "translate(350.903 0.964)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43",
    "data-name": "Caminho 43",
    d: "M1210.968,55.012H1180.5l-4.725,12.342h-12.342L1188.695,3.04h14.078l25.262,64.314h-12.342Zm-27.287-9.932h24.106l-12.053-32.494Z",
    transform: "translate(-794.306 -2.075)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_44",
    "data-name": "Caminho 44",
    d: "M0,282.166H25.983v5.1H5.8v11.31H25.577v5.1H5.8v12.063H25.983v5.1H0Z",
    transform: "translate(0 -192.642)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_45",
    "data-name": "Caminho 45",
    d: "M147.678,305.075l-11.6,15.775H129.06l14.847-19.835L129.93,282.166h7.018l10.73,14.847,10.672-14.847h7.018l-13.861,18.791,14.731,19.893h-6.96Z",
    transform: "translate(-88.113 -192.642)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_46",
    "data-name": "Caminho 46",
    d: "M297.788,282.166h16.3c7.946,0,12.354,5.452,12.354,11.889s-4.466,11.889-12.354,11.889h-10.5V320.85h-5.8Zm15.543,5.1h-9.743v13.571h9.743c4.176,0,7.134-2.726,7.134-6.786s-2.958-6.786-7.134-6.786",
    transform: "translate(-203.308 -192.642)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_47",
    "data-name": "Caminho 47",
    d: "M443.481,282.166h25.983v5.1H449.281v11.31h19.777v5.1H449.281v12.063h20.183v5.1H443.481Z",
    transform: "translate(-302.776 -192.642)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_48",
    "data-name": "Caminho 48",
    d: "M597.839,305.945h-7.25V320.85h-5.8V282.166h16.3c7.366,0,12.412,4.756,12.412,11.889,0,6.96-4.7,10.672-9.628,11.31l9.918,15.485H607.06Zm2.494-18.675h-9.743v13.571h9.743c4.176,0,7.192-2.726,7.192-6.786s-3.016-6.786-7.192-6.786",
    transform: "translate(-399.251 -192.642)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_12",
    "data-name": "Ret\\xE2ngulo 12",
    width: 5.8,
    height: 38.685,
    transform: "translate(232.981 89.524)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_49",
    "data-name": "Caminho 49",
    d: "M816.4,282.166h25.983v5.1H822.2v11.31h19.777v5.1H822.2v12.063h20.183v5.1H816.4Z",
    transform: "translate(-557.378 -192.642)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_50",
    "data-name": "Caminho 50",
    d: "M963.509,291.155V320.85h-5.8V282.166h5.974l21.053,29v-29h5.8V320.85h-5.625Z",
    transform: "translate(-653.853 -192.642)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_51",
    "data-name": "Caminho 51",
    d: "M1119.673,300.164c0-11.889,8.816-20.009,19.835-20.009a17.493,17.493,0,0,1,15.369,8.178l-4.93,2.61a12.262,12.262,0,0,0-10.44-5.626c-7.83,0-13.861,6.148-13.861,14.847,0,8.642,6.032,14.847,13.861,14.847a12.262,12.262,0,0,0,10.44-5.626l4.93,2.61a17.566,17.566,0,0,1-15.369,8.177c-11.02,0-19.835-8.12-19.835-20.009",
    transform: "translate(-764.43 -191.269)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_52",
    "data-name": "Caminho 52",
    d: "M1285.474,282.166h25.983v5.1h-20.184v11.31h19.777v5.1h-19.777v12.063h20.184v5.1h-25.983Z",
    transform: "translate(-877.627 -192.642)",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(881.99 239.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_53",
    "data-name": "Caminho 53",
    d: "M179.3,114.279l-17.34,17.34,8.659,8.659-4.335,4.335-4.335-4.335h0l-4.335-4.335-8.67,8.67-4.335-4.335,8.681-8.681-.005-.006h0l-13-13h0l-13,13-.011.011,8.67,8.67-4.324,4.324-13-13,19.964-19.964h26.011L153.3,122.922l4.335,4.335,15.623-15.623h.011L179.4,105.5h-.011l.005-.005-3.914.005H136.049l-.006-.006-26.111,26.111,4.335,4.335.011-.011,13,13,4.335,4.335,4.335-4.335,4.324-4.324,4.335,4.335-4.335,4.335h0l-4.335,4.335,8.67,8.67-4.335,4.335-8.681-8.681-.005.005h0l-13,13,4.335,4.335,4.346,4.346h0l4.335,4.335,8.67-8.67,4.324,4.324-13,13.005-19.964-19.964V150.648l11.289,11.289,4.335-4.335-15.623-15.623v-.011l-6.131-6.13v.011l-.006-.006.006,3.9v39.444l-.006.006L131.608,205.3l4.335-4.335-.011-.011,17.34-17.34-8.659-8.659,4.335-4.335,4.335,4.335h0l4.335,4.335,8.67-8.67,4.335,4.335-8.681,8.681.005.005h0l13,13h0l8.681-8.681,4.324-4.324.011-.011-8.67-8.67,4.324-4.324,13,13.005L176.658,203.6H150.647l11.289-11.289-4.335-4.335L141.978,203.6h-.011l-6.13,6.131h.011l-.006.006,3.914-.006h39.43l.006.006L205.3,183.628l-4.335-4.335-.011.011-13-13-4.335-4.335-4.335,4.335-4.324,4.324-4.335-4.335,4.335-4.335h0l4.335-4.335-8.67-8.67,4.335-4.335,8.681,8.681.005-.005h0l13-13h0l-4.335-4.335-4.346-4.346-4.324-4.324-.011-.011-8.67,8.67-4.324-4.324,13.005-13L203.6,138.577v26.011L192.314,153.3l-4.335,4.335L203.6,173.258v.011l6.131,6.13v-.011l.006.006-.006-3.9V136.05l.006-.006-26.111-26.111-4.335,4.335Zm-43.361,17.329,4.346-4.346,4.335,4.335-4.346,4.346Zm-4.335,47.685-4.346-4.346,4.335-4.335,4.346,4.346Zm47.685,4.335-4.346,4.346-4.335-4.335,4.346-4.346Zm-21.675-39.015,4.335,4.335-4.335,4.335-4.335-4.335Zm-13,13.005,4.335-4.335,4.335,4.335-4.335,4.335Zm13,13.005-4.335-4.335,4.335-4.335,4.335,4.335Zm13.005-13.005-4.335,4.335-4.335-4.335,4.335-4.335Zm13-21.675,4.346,4.346-4.335,4.335-4.346-4.346Z",
    transform: "translate(-93.246 -93.246)",
    fill: "#b79b5e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_54",
    "data-name": "Caminho 54",
    d: "M6.131,88.5V40.249L40.247,6.132H88.5l34.117,34.117V88.5L88.5,122.614H40.247ZM37.708,0,0,37.71V91.037l37.708,37.708H91.035l37.708-37.708V37.71L91.035,0Z",
    transform: "translate(0 -0.002)",
    fill: "#b79b5e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssentiaExperience);
export default __webpack_public_path__ + "static/media/essentia-experience.9bec4b1ccd5381617fe19bd264f05633.svg";
export { ForwardRef as ReactComponent };